import React, { useEffect, useState } from 'react';
import { checkTagValidity } from '../../Utils/Utils';
import { Configuration } from '../../components/Widget/Configuration';
import { Tabs } from '../../components/Widget/Tab';
import { useConfigStore } from '../../store/ConfigStore';
import { Commentaire } from './Commentaires';
import { Creneaux } from './Creneaux';
import { DistancePBO } from './DistancePBO';
import { Forfait } from './Forfait';
import { RolePermission } from './RolePermission';
import { Role } from './Roles';
import { SLA } from './SLA';
import { TypeBatiment } from './TypeBatiment';
import { TypeEquipement } from './TypeEquipement';

const Parametres = () => {

  const [active, setActive] = useState({ index: 0, value: 'Type equipement', tag: "LISTE_TYPE_EQUIPEMENT" });
  const configs = [
    { index: 0, value: 'Type equipement', tag: "LISTE_TYPE_EQUIPEMENT" },
    { index: 1, value: 'Crenaux horaires', tag: "LISTE_CRENEAUX" },
    { index: 2, value: 'Type de batiment', tag: "LISTE_TYPE_BATIMENT" },
    { index: 3, value: 'Forfait', tag: "LISTE_FORFAIT" },
    { index: 4, value: 'Type commentaire', tag: "LISTE_TYPE_COMMENTAIRE" },
    { index: 5, value: "Nombre d'opération par jour", tag: "NOMBRE_OPERATION" },
    { index: 6, value: "Gestion de permission", tag: "GESTION_PERMISSION" },
    { index: 7, value: "Role", tag: "LISTE_ROLE" },
    { index: 8, value: "SLA", tag: "SLA" },
    { index: 9, value: "Distance PBO", tag: "DISTANCE_PBO" },
  ]
  const totalOperations = useConfigStore()
  const distancePBO = useConfigStore()
  const filteredTabsData = configs
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0])
    }
    totalOperations.getData()
    distancePBO.getDistancePBO()
  }, [])

  return (
    <div className=''>
      <div className="lg:flex gap-x-2 ">
        {/* <button className='btn bg-white btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button> */}
        <h1 className="font-mtn text-3xl font-extrabold text-black my-auto">
          Parametres
        </h1>
      </div>
      <div className='bg-white rounded-md px-3 py-2 mt-12'>
        {filteredTabsData.length !== 0 ? <Tabs tabsData={filteredTabsData} active={active} setActive={setActive} /> : null}
        {
          active.tag === 'LISTE_TYPE_EQUIPEMENT' ?
            <TypeEquipement />
            : active.tag === 'LISTE_CRENEAUX' ?
              <Creneaux />
              : active.tag === 'LISTE_TYPE_BATIMENT' ?
                <TypeBatiment />
                : active.tag === 'LISTE_FORFAIT' ?
                  <Forfait />
                  : active.tag === 'LISTE_TYPE_COMMENTAIRE' ?
                    <Commentaire />
                    : active.tag === 'NOMBRE_OPERATION' ?
                      <Configuration defaultValue={totalOperations?.data?.donnee} description={"Nombre d'operation par équipe"} message={"Nombre d'operation appliqué"} />
                      : active.tag === 'GESTION_PERMISSION' ?
                        <RolePermission />
                        : active.tag === 'LISTE_ROLE' ? <Role />
                          : active.tag === 'SLA' ? <SLA />
                            : <DistancePBO defaultValue={distancePBO?.distancePBO.donnee} description={"Distance PBO"} message={"Distance PBO appliqué"} />
        }

      </div>
    </div>
  )
}

export default Parametres